<template>
  <div>
    <Accordion>
      <AccordionItem>
        <template slot="accordion-trigger">
          <h4>{{ $t("home.accordion_header1") }} <span class="openCloseIcon"></span></h4>
        </template>

        <template slot="accordion-content">
          <div class="content">{{ $t("home.accordion_text1") }}</div>
        </template>
      </AccordionItem>
      <AccordionItem>
        <template slot="accordion-trigger">
          <h4>{{ $t("home.accordion_header2") }} <span class="openCloseIcon"></span></h4>
        </template>

        <template slot="accordion-content">
          <div class="content">{{ $t("home.accordion_text2") }}</div></template>
      </AccordionItem>
      <AccordionItem>
        <template slot="accordion-trigger">
          <h4>{{ $t("home.accordion_header3") }} <span class="openCloseIcon"></span></h4>
        </template>

        <template slot="accordion-content">
          <div class="content">{{ $t("home.accordion_text3") }}
          </div></template>
      </AccordionItem>
      <AccordionItem>
        <template slot="accordion-trigger">
          <h4>{{ $t("home.accordion_header4") }} <span class="openCloseIcon"></span></h4>
        </template>

        <template slot="accordion-content">
          <div class="content">
            <p v-html="$t('home.accordion_text4_1')"></p>
          </div></template>
      </AccordionItem>
      <AccordionItem>
        <template slot="accordion-trigger">
          <h4>{{ $t("home.accordion_header5") }} <span class="openCloseIcon"></span></h4>
        </template>

        <template slot="accordion-content">
          <div class="content">
            <p>{{ $t("home.accordion_text5") }}</p>
          </div></template>
      </AccordionItem>
      <AccordionItem>
        <template slot="accordion-trigger">
          <h4>{{ $t("home.accordion_header6") }} <span class="openCloseIcon"></span></h4>
        </template>

        <template slot="accordion-content">
          <div class="content">
            <p>{{ $t("home.accordion_text6") }}</p>
          </div></template>
      </AccordionItem>
      <AccordionItem>
        <template slot="accordion-trigger">
          <h4>{{ $t("home.accordion_header7") }} <span class="openCloseIcon"></span></h4>
        </template>

        <template slot="accordion-content">
          <div class="content">
            <p>{{ $t("home.accordion_text7") }}</p>
          </div></template>
      </AccordionItem>
      <AccordionItem>
        <template slot="accordion-trigger">
          <h4>{{ $t("home.accordion_header8") }} <span class="openCloseIcon"></span></h4>
        </template>

        <template slot="accordion-content">
          <div class="content">
            <p>{{ $t("home.accordion_text8") }}</p>
          </div></template>
      </AccordionItem>
    </Accordion>

  </div>
</template>
<script>
import Accordion from "@/components/Accordion/Accordion";
import AccordionItem from "@/components/Accordion/Accordion-item";
export default {
  data() {
    return {
    };
  },
  computed: {},
  components: {AccordionItem, Accordion},

};
</script>
<style scoped src="@/assets/css/bootstrap.css"></style>
<style>
</style>